"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import OemArchitectureImg from "./components/architectureImg";
import FeaturesComponent from "./components/features";
import ServicesComponent from "./components/services";
import FeaturesComparsion from "./components/comparison";

const OemConvergedArchitecturePage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PrivateCloudTabs />
        <Intro />
        <OemArchitectureImg />
        <FeaturesComponent />
        <ServicesComponent />
        <FeaturesComparsion />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default OemConvergedArchitecturePage;
